module.exports = __webpack_public_path__ + "img/time-table-default.fa7b9652.svg";